<template>
  <div @click="hideUploadEwm">
      <div class="loginBody" >
          <div class="topBody">
            <img style="margin-left: 100px;height: 23px" src="../../static/img/logo_2.png" alt="">
            <img style="margin-left: 12px;height: 14px" src="../../static/img/link.png" alt="">
          </div>
      </div>

    <div class="contentBody">
        <div class="contentLeft">
          <div class="smdl">扫码登录</div>
          <div class="smms">打开我说下APP<br/>在「动态事务」右上角打开扫一扫</div>
          <img style="width: 190px;height: 190px;margin-top: 10px;" src="../../static/img/smdl.png" alt="">
          <div class="az_ios_body">
            <div @click="showUploadEwm('ios')" class="btn_body">
              <img src="../../static/img/ios_ico.png" alt="">
              <span>iPhone版下载</span>
              <div v-show="ios_ewm" class="ios_ewm">
                <img src="../../static/img/ios_xz.png" alt="">
              </div>
            </div>
            <div style="margin-left: 14px;" @click="showUploadEwm('az')" class="btn_body">
              <img src="../../static/img/az_ico.png" alt="">
              <span>安卓版下载</span>
              <div v-show="az_ewm" class="ios_ewm">
                <img src="../../static/img/az_xz.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="contentCen"></div>
        <div class="contentRight">
          <div v-if="type == 'login'" >
            <div class="login_title">欢迎登录我说下</div>
            <div class="input_body">
              <div v-if="login.email" class="input_spk">邮箱/手机号</div>
              <div v-else class="input_spk"></div>

              <input type="text" v-model="login.email" v-on:keyup.enter="loginSub()" placeholder="请输入邮箱/手机号" />
            </div>

            <div class="input_body">
              <div v-if="login.password" class="input_spk">登录密码</div>
              <div v-else class="input_spk"></div>
              <input type="password" placeholder="请输入登陆密码" v-on:keyup.enter="loginSub()" v-model="login.password" show-password />
            </div>

            <div class="login_sub_btn" @click="loginSub()">登录</div>

            <div class="forget_pwd" @click="forgetPassWord()">忘记密码？</div>

          </div>
          <div v-else>
            <div class="login_title">欢迎注册</div>
            <div class="input_body">
              <div v-if="reg.name" class="input_spk">真实姓名</div>
              <div v-else class="input_spk"></div>

              <input type="text" v-model="reg.name" v-on:keyup.enter="toUploadPhoto()" placeholder="您的真实姓名" />
            </div>

            <div class="input_body">
              <div v-if="reg.email" class="input_spk">常用邮箱</div>
              <div v-else class="input_spk"></div>

              <input type="text" v-model="reg.email" v-on:keyup.enter="toUploadPhoto()" placeholder="请输入常用邮箱" />
            </div>

            <div class="input_body">
              <div v-if="reg.tel" class="input_spk">常用手机号</div>
              <div v-else class="input_spk"></div>

              <input type="text" v-model="reg.tel" v-on:keyup.enter="toUploadPhoto()" placeholder="请输入常用手机号" />
            </div>

            <div class="input_body">
              <div v-if="reg.code" class="input_spk">验证码</div>
              <div v-else class="input_spk"></div>

              <div class="code_body">
                <input type="text" v-model="reg.code" v-on:keyup.enter="toUploadPhoto()" placeholder="请输入验证码" />
                <div class="code-btn" style="margin-right: 10px;" @click="onClickSend">{{sendText}}</div>
              </div>

            </div>

            <div class="input_body">
              <div v-if="reg.password" class="input_spk">登录密码</div>
              <div v-else class="input_spk"></div>
              <input type="password" v-model="reg.password" v-on:keyup.enter="toUploadPhoto()" placeholder="请设置登录密码" />
            </div>

            <div class="input_body">
              <div v-if="reg.agent_code" class="input_spk">邀请码</div>
              <div v-else class="input_spk"></div>

              <input type="text" v-model="reg.agent_code" v-on:keyup.enter="toUploadPhoto()" placeholder="填写邀请码:非必填" />
            </div>

            <div class="login_sub_btn" @click="toUploadPhoto()">我要注册</div>
          </div>
        </div>

      <div class="top_tag">
        <img v-if="type == 'login'" title="立即注册" @click="upType()" src="../../static/img/reg_btn.png" alt="">
        <img v-else  @click="upType()" title="前往登陆" src="../../static/img/login_btn.png" alt="">
      </div>
    </div>

    <div class="botBody">
      <div class="botText">
        woshuoxia&nbsp;&nbsp;2019 - {{currentYear}}
        <a @click="toBeian()" style="color: grey;" href="https://beian.miit.gov.cn/#/Integrated/index" _target="_blank">ICP备案号：蜀ICP备2020025859号-1</a>
        <a @click="toBeian()" style="color: grey;" href="https://beian.miit.gov.cn/#/Integrated/index" _target="_blank">APP备案号：蜀ICP备2020025859号-2A</a>
      </div>
    </div>
  </div>
</template>

<script>
import Bfooter from "../components/footer"; //上传图片
import md5 from '../../commonFunction/md5';
export default {
  name: "App",
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  data() {
    return {
        sendText:'|  获取验证码',
        currentYear:'',
        ios_ewm:false,
        az_ewm:false,
        type:'login',
        count:60,
        login:{
            email: "",
            password: ""
        },
        reg:{
            name: "",
            email: "",
            tel: "",
            code: "",
            password: "",
            agent_code:""
        }

    };
  },
  created(){
      let _this=this;
      _this.currentYear = new Date().getFullYear();
      this.loginGet();
      if(_this.common.isLogin()){
          _this.toHome();
      }

  }
,
  methods:{

      //点击发送验证码
      onClickSend(){
          let _this=this;

          if(_this.count != 60){
              _this.common.vMessage('请等待 '+_this.count+' s','warning');
              return;
          }


          _this.common.request('api/user/checkTel',{tel:_this.reg.tel},function (res) {
             if(res.status == 200){
                 let data={
                     tel:_this.reg.tel,
                     sign:md5(md5(_this.reg.tel+_this.common.smsSignKey()))
                 };
                 _this.common.request('code/send',data,function(res){
                     if(res.status == 200){
                         _this.common.vMessage(res.message);
                         let sendIn=setInterval(function(){
                             _this.sendText=_this.count+' s';
                             _this.count--;
                             if(_this.count<=0){
                                 _this.sendText='重新发送';
                                 _this.count=60;
                                 clearInterval(sendIn);//清除定时器
                             }
                         },1000);

                     }
                 },'post')
             }
          },'post');


      },
      toBeian(){
          window.open('https://beian.miit.gov.cn/#/Integrated/index');
      },
      //记录访问次数
      loginGet(){
        this.common.request('api/systemCount/loginGet',{},function (res) {

        })
      },
      //忘记密码
      forgetPassWord(){
          this.$router.push('/forgetPassWord');
      },
      toTiYan(){
          this.$router.push('/recommend');
      },

      showUploadEwm(type){
          if (type == 'ios'){
              this.ios_ewm=!this.ios_ewm;
              this.az_ewm=false;
          } else {
              this.az_ewm=!this.az_ewm;
              this.ios_ewm=false;
          }
      },
      hideUploadEwm(event){
          // 检查事件是否来自于div元素之外
          if (!event.target.closest('.btn_body')) {
              this.az_ewm=false;
              this.ios_ewm=false;
          }

      },
      //去主页
      loginSub(){
          //调用接口
          let _this=this;
          _this.common.request('api/user/login',_this.login,function (res) {
              console.log(res);
              if(res.status == 200){
                  localStorage.setItem('_token',res.data['user-token']);
                  localStorage.setItem('userInfo',JSON.stringify(res.data));
                  if(document.getElementsByClassName('el-message').length < 1) {
                      _this.$message({
                          message: res.message,
                          type: 'success',
                          duration: 1500,
                          center: true,
                          onClose: function (res) {
                              _this.toHome();
                          }
                      });
                  }
              }
          },'post');
      },
      toHome(){
          this.$router.push('/dynamic')
      },
      upType(){
        this.type = (this.type == 'login') ? 'reg' : 'login';
          this.login={
              email: "",
                  password: ""
          };
          this.reg={
              name: "",
                  email: "",
                  tel: "",
                  code: "",
                  password: "",
                  agent_code:""
          }
      },
      //注册
      toUploadPhoto(){
          let _this = this;
          _this.common.request('api/user/checkRegister',_this.reg,function (res) {
              if(res.status == 200){
                  //存在邀请码 进行验证
                  if (_this.reg.agent_code){
                      _this.common.request('api/agent/checkCode',{code:_this.reg.agent_code},function (res) {
                         if (res.status ==200){
                             _this.$router.push({
                                 name:'uploadPhoto',
                                 params:_this.reg
                             });
                         }
                      },'post');
                  }else {
                      _this.$router.push({
                          name:'uploadPhoto',
                          params:_this.reg
                      });
                  }
              }
          },'post')
      }
  }
  ,
  components: {
    Bfooter
  }
};
</script>

<style scoped lang='less'  rel="stylesheet/less">
@import "../assets/css/index.less";
  body{
      background: #fff;
    }
*{
  padding: 0;
  font-family:Microsoft YaHei!important;
}
.loginBody{
  width: 100%;
  height: 100%;
  position: fixed;
  background-image: url('../../static/img/bg.png'); /* 替换为你的图片路径 */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
  .topBody{
    width: 100%;
    height: 72px;
    background: rgba(255,255,255,0.6);
    display: flex;
    align-items: center;
  }

  .contentBody{
    width: 768px;
    height: 600px;
    background: rgba(255,255,255,0.8);
    box-shadow: 0px 0px 10px 0px rgba(156,163,172,0.1);
    border-radius: 4px 4px 4px 4px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    align-items: center;
    display: flex;
    .contentLeft{
      width: 46%;
      text-align: center;
      .smdl{
        font-family:Microsoft YaHei;
        font-weight: 500;
        font-size: 24px;
        color: #43494D;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    .smms{
      font-family:Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #9BACB8;
      line-height: 14px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-top: 30px;
      }

      .az_ios_body{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        .btn_body{
          cursor: pointer;
          width: 134px;
          height: 36px;
          border-radius: 24px 24px 24px 24px;
          border: 1px solid #4592F5;
          font-family:Microsoft YaHei;
          font-weight: 500;
          font-size: 14px;
          color: #4592F5;
          line-height: 36px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          img{
            margin-right: 6px;
          }
          .ios_ewm{
            position: absolute;
            bottom: -166px;
            left: -10px;
            width: 146px;
            height: 168px;
            background-image: url('../../static/img/ewm_body.png'); /* 替换为你的图片路径 */
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            img{
              width: 136px;
              margin-top: 22px;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .contentCen{
      width: 1px;
      height: 480px;
      background: #DDE4ED;
      border-radius: 0px 0px 0px 0px;
    }

    .contentRight{
      width: 54%;
      text-align: center;
      .login_title{
        font-family:Microsoft YaHei;
        font-weight: 400;
        font-size: 24px;
        color: #43494D;
        line-height: 28px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 10px;
      }
      .input_body{
        width: 300px;
        margin: 0 auto;
      }
      .input_spk{
        text-align: left;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #4592F5;
      }
      input{
        text-indent: 10px;
        width: 298px;
        height: 38px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #9BACB8;
        /*color: #9BACB8;*/
        background: none;
      }
      input:focus{
        border: 1px solid #4592F5;
      }
      input::-webkit-input-placeholder {
        color: #9BACB8;
      }
      .code_body{
        position: relative;
        div{
          width: 86px;
          height: 17px;
          font-family:Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #4588F5;
          line-height: 16px;
          text-align: right;
          font-style: normal;
          text-transform: none;
          position: absolute;
          right: 0;
          top: 12px;
          cursor: pointer;
        }
      }
      .login_sub_btn{
        width: 300px;
        height: 36px;
        background: rgba(24,120,243,0.8);
        border-radius: 4px 4px 4px 4px;

        font-family:Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 1px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        line-height: 36px;
        margin: 30px auto 16px;
        cursor: pointer;
      }
      .forget_pwd{
        width: 300px;
        font-family:Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #4592F5;
        line-height: 16px;
        text-align: right;
        font-style: normal;
        text-transform: none;
        margin: 0 auto;
        cursor: pointer;
      }
    }

    .top_tag{
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }

  .botBody{
    position: absolute;
    bottom: 20px;
    height: 17px;
    width: 100%;
    text-align: center;
    .botText{
      font-family:Microsoft YaHei;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      line-height: 16px;
      font-style: normal;
      text-transform: none;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/login.vue